import React from 'react';

import { IconPhone } from '@tabler/icons-react';
import { CalDotcomAccountHandler } from 'components/CaldotcomAccountHandler/CaldotcomAccountHandler';
import { FacebookAccountHandler } from 'components/FacebookAccountHandler/FacebookAccountHandler';
import { GoogleDriveAccountHandler } from 'components/GoogleDriveAccountHandler/GoogleDriveAccountHandler';
import { InstagramAccountHandler } from 'components/InstagramAccountHandler/InstagramAccountHandler';
import { TelephonySection } from 'components/SmartAssistantSections/TelephonySection/TelephonySection';
import { WhatsAppAccountHandler } from 'components/WhatsAppAccountHandler/WhatsAppAccountHandler';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { CaldotcomIcon } from 'icons/Caldotcom';
import { FacebookIcon } from 'icons/FacebookIcon';
import { GoogleDriveIcon } from 'icons/GoogleDriveIcon';
import { InstagramIcon } from 'icons/InstagramIcon';
import { WhatsAppIcon } from 'icons/WhatsAppIcon';
import { ZapierIcon } from 'icons/ZapierIcon';
import { ApiKeysTable } from 'pages/Settings/SettingTabs/ApiKeysTable';
import { SettingsSectionWrapper } from 'pages/Settings/SettingTabs/SettingsSectionWrapper';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { IntegrationType } from 'shared/enums/integration';

export function IntegrationSettingTab() {
  const { t } = useTranslation();
  const location = useLocation();
  const { type } = queryString.parse(location.search);

  const [subscription] = useSubscriptionContext();

  switch (type as IntegrationType) {
    case IntegrationType.ZAPIER:
      if (!subscription.product.enableZapierAccess) break;
      return (
        <SettingsSectionWrapper title={t('ZAPIER.TITLE')} icon={<ZapierIcon h={20} w={20} />} h="100%">
          <ApiKeysTable isZapierKey={true} h="100%" />
        </SettingsSectionWrapper>
      );
    case IntegrationType.GOOGLE_DRIVE:
      if (!subscription.product.enableGoogleDrive) break;
      return (
        <SettingsSectionWrapper title={t('GOOGLE_DRIVE.TITLE')} icon={<GoogleDriveIcon h={20} w={20} />} h="100%">
          <GoogleDriveAccountHandler h="100%" />
        </SettingsSectionWrapper>
      );
    case IntegrationType.WHATSAPP:
      if (!subscription.product.enableWhatsApp) break;
      return (
        <SettingsSectionWrapper title={t('WHATSAPP.TITLE')} icon={<WhatsAppIcon h={20} w={20} />} h="100%">
          <WhatsAppAccountHandler h="100%" />
        </SettingsSectionWrapper>
      );
    case IntegrationType.FACEBOOK:
      if (!subscription.product.enableFacebook) break;
      return (
        <SettingsSectionWrapper title={t('FACEBOOK.TITLE')} icon={<FacebookIcon h={20} w={20} />} h="100%">
          <FacebookAccountHandler h="100%" />
        </SettingsSectionWrapper>
      );

    case IntegrationType.INSTAGRAM:
      if (!subscription.product.enableInstagram) break;
      return (
        <SettingsSectionWrapper title={t('INSTAGRAM.TITLE')} icon={<InstagramIcon h={20} w={20} />} h="100%">
          <InstagramAccountHandler h="100%" />
        </SettingsSectionWrapper>
      );
    case IntegrationType.PHONE_NUMBER:
      return (
        <SettingsSectionWrapper
          title={t('PHONE_NUMBER.TITLE')}
          icon={<IconPhone style={{ height: 22, width: 22 }} />}
          h="100%">
          <TelephonySection />
        </SettingsSectionWrapper>
      );
    case IntegrationType.CALDOTCOM:
      return (
        <SettingsSectionWrapper title={t('CALDOTCOM.TITLE')} icon={<CaldotcomIcon h={20} w={20} />} h="100%">
          <CalDotcomAccountHandler h="100%" />
        </SettingsSectionWrapper>
      );
  }

  return <Navigate to={ROUTE_LINKS.integrations} replace />;
}
